module.exports = __webpack_public_path__ + "static/media/joker.558a63ee.gif";